"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PlainButton_1 = __importDefault(require("../../buttons/PlainButton"));
var DoorEffect_1 = __importDefault(require("../../DoorEffect"));
var Icon_1 = __importDefault(require("../../Icon"));
var isCreatingOption = function (_a) {
    var display = _a.display, multiple = _a.multiple, options = _a.options, value = _a.value;
    var matchedLabel = options.some(function (option) { return option.label.toLowerCase() === (display === null || display === void 0 ? void 0 : display.toLowerCase()); });
    if (!multiple) {
        return !matchedLabel && display !== value;
    }
    var multiValue = value;
    return !matchedLabel && (!multiValue || !multiValue.some(function (item) { return item === display; }));
};
var SelectFieldOption = react_1.default.memo(function (_a) {
    var current = _a.current, option = _a.option, onDeselect = _a.onDeselect, onSelect = _a.onSelect, tabIndex = _a.tabIndex, created = _a.created;
    var label = option.label, value = option.value, icon = option.icon, category = option.category;
    var onClick = function () { return (current ? onDeselect : onSelect)(value, category || ""); };
    return (react_1.default.createElement(PlainButton_1.default, { id: created ? "create-field-option" : "select-field-option", className: "chq-ffd--sl--opts-chq-pbn", "aria-current": current, "aria-label": (current ? "Unselect" : "Select") + " " + label + (category ? " - " + category : ""), onClick: onClick, tabIndex: tabIndex },
        icon && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Icon_1.default, { className: "option-icon", icon: icon }),
            " "),
        label,
        category && react_1.default.createElement("span", { className: "option-category" },
            " ",
            "(",
            category,
            ")")));
});
var makeCurrentMatcher = function (_a) {
    var multiple = _a.multiple, value = _a.value;
    if (value === undefined || value === null) {
        return function () { return false; };
    }
    if (multiple) {
        if (typeof value[0] === "string" || typeof value[0] === "number") {
            return function (option) { return value.includes(option.value); };
        }
        return function (option) {
            var result = value.filter(function (item) { return item.value === option.value
                && option.category === item.category; });
            return result.length > 0;
        };
    }
    return function (option) { return value === option.value; };
};
var SelectFieldOptions = react_1.default.memo(function (_a) {
    var allowEmpty = _a.allowEmpty, creatable = _a.creatable, creatableLabel = _a.creatableLabel, display = _a.display, filteredOptions = _a.filteredOptions, multiple = _a.multiple, onDeselect = _a.onDeselect, onSelect = _a.onSelect, open = _a.open, options = _a.options, value = _a.value;
    var createOption = creatable && isCreatingOption({ display: display, multiple: multiple, options: options, value: value });
    var currentMatcher = makeCurrentMatcher({ multiple: multiple, value: value });
    return (react_1.default.createElement("div", null, !allowEmpty && (react_1.default.createElement(DoorEffect_1.default, { className: "chq-ffd--sl--opts", open: open },
        createOption && ((display === null || display === void 0 ? void 0 : display.length) > 0) && (react_1.default.createElement(SelectFieldOption, { key: display, current: false, onDeselect: onDeselect, onSelect: onSelect, option: { label: ((creatableLabel === null || creatableLabel === void 0 ? void 0 : creatableLabel.length) > 0 ? creatableLabel : "Create option") + ": " + display, value: display }, tabIndex: open ? 0 : -1, created: true })),
        filteredOptions.map(function (option) { return (react_1.default.createElement(SelectFieldOption, { key: option.category + "-" + option.value, current: currentMatcher(option), onDeselect: onDeselect, onSelect: onSelect, option: option, tabIndex: open ? 0 : -1, created: false })); }),
        !createOption && ((filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) === 0) && (react_1.default.createElement("p", null, "No results found."))))));
});
exports.default = SelectFieldOptions;
